// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1DNp9","buttons":"PendingPaymentAlert_buttons__2g8U-"};